<div #header mat-dialog-title>Manage Reports in Folder</div>
<div style="padding-left: 10px;">{{folderName}}</div>

<mat-dialog-content>
    <!-- Grid -->
    <mat-table #table id="tblReports" [dataSource]="reportsTableData" multiTemplateDataRows style="width: 100%;">
        <!-- ParentCheckbox -->
        <ng-container matColumnDef="ParentCheckbox">
            <mat-header-cell *matHeaderCellDef translate>
                <tyl-checkbox id="parentCheckbox" name="parentCheckbox"
                    [(checked)]="parentAllCheckBox" [indeterminate]="checkIndeterminate"
                    (change)="parentAllCheckBoxChange()">
                </tyl-checkbox>
            </mat-header-cell>

            <mat-cell *matCellDef="let rpt; let j = dataIndex" class="print-ignore">
                <tyl-checkbox id="childCheckbox_{{j}}" name="childCheckbox_{{j}}"
                    [(checked)]="rpt.IsSelected" (change)="parentCheckBoxChange(rpt)" [indeterminate]="rpt.checkRowIndeterminate"
                    (click)="$event.stopPropagation();">
                </tyl-checkbox>
            </mat-cell>
        </ng-container>

        <!-- More -->
        <ng-container matColumnDef="More">
            <mat-header-cell *matHeaderCellDef translate>
                <span *ngIf="reportsTableData.data.length > 0"
                    class="material-icons" [ngClass]="{'detail-row-expanded-icon': isReportsRowsExpanded, 'detail-row-collapsed-icon': !isReportsRowsExpanded}"
                    (click)="expandAll(isReportsRowsExpanded)"></span>
            </mat-header-cell>
            <mat-cell *matCellDef="let rpt">
                <span *ngIf="reportsTableData.data.length > 0"
                    class="material-icons" [ngClass]="{'detail-row-expanded-icon': reportsTableData.checkExpanded(rpt),'detail-row-collapsed-icon': !reportsTableData.checkExpanded(rpt)}"></span>
            </mat-cell>
        </ng-container>

        <!-- Report Caregory -->
        <ng-container matColumnDef="Description">
            <mat-header-cell *matHeaderCellDef translate>
                Report Category
            </mat-header-cell>
            <mat-cell *matCellDef="let rpt">
                {{rpt.Description}}
            </mat-cell>
        </ng-container>

        <!-- Child Report Table -->
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let rpt; let i = dataIndex" style="width:100%;" class="mat-detail-card">
                <table class="mat-table" style="width: 100%;">
                    <tr class="mat-row" *ngFor="let rt of rpt.ReportsList;">
                        <td class="mat-cell">
                            <tyl-checkbox id="reportCheckbox_{{i}}_{{rt.Id}}" name="reportCheckbox_{{i}}_{{rt.Id}}"
                                [(checked)]="rt.IsSelected" (change)="childCheckBoxChange(rpt)">
                            </tyl-checkbox>
                        </td>
                        <td class="mat-cell">
                            {{rt.Description}}
                        </td>
                    </tr>
                </table>
            </mat-cell>
        </ng-container>

        <!-- Row Definitions -->
        <mat-header-row *matHeaderRowDef="reportsTableColumns; sticky: true;"></mat-header-row>
        <mat-row *matRowDef="let rpt; columns: reportsTableColumns; let i = dataIndex" id="report{{rpt.Id}}"
            tabIndex="0" style="padding:0px;overflow: hidden;"
            (click)="(rpt.ReportsList != null && rpt.ReportsList.length > 0) ? reportsTableData.toggleExpanded(rpt) : null">
        </mat-row>
        <mat-row *matRowDef="let rpt; columns: ['expandedDetail']"
            [@detailExpand]="rpt.ReportsList != null && rpt.ReportsList.length > 0 && reportsTableData.checkExpanded(rpt) ? 'expanded' : 'collapsed'"
            style="overflow: hidden;" class="mat-detail-row"></mat-row>

    </mat-table>
</mat-dialog-content>

<mat-dialog-actions #footer>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="save.png" label="Save" (click)="saveClick()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (click)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>